interface DateRangeProps {
  startDate: string;
  endDate: string;
}

const formatDate = (dateString: string) => {
  return new Date(dateString)
    .toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
    .replace(/\. /g, '.')
    .replace(/\.$/, '');
};

export const DateRange = ({ startDate, endDate }: DateRangeProps) => {
  return (
    <span>
      {formatDate(startDate)} - {formatDate(endDate)}
    </span>
  );
}; 